export interface TopicGroup {
  id: string;
  label: string;
  icon: string;
  topics: { name: string; heat: number; rise: number }[];
}

export const topicGroups: TopicGroup[] = [
  {
    id: "gather",
    label: "现场聚集",
    icon: "ri-group-line",
    topics: [
      { name: "开业排队长龙现场", heat: 982, rise: 12 },
      { name: "夜校市集人流实况", heat: 873, rise: 8 },
      { name: "大屏观赛聚集区", heat: 761, rise: 15 },
      { name: "跨年倒计时人群", heat: 648, rise: 4 },
      { name: "快闪活动围堵实拍", heat: 592, rise: 21 },
      { name: "展会门口人从众", heat: 517, rise: 6 },
    ],
  },
  {
    id: "react",
    label: "围观反应",
    icon: "ri-chat-smile-3-line",
    topics: [
      { name: "第一排到底看到了啥", heat: 905, rise: 19 },
      { name: "现场一片惊呼瞬间", heat: 834, rise: 11 },
      { name: "举着手机都在拍什么", heat: 712, rise: 7 },
      { name: "散场后的回头讨论", heat: 639, rise: 9 },
      { name: "人群里的高能反应", heat: 586, rise: 14 },
      { name: "围观眼神集体一致", heat: 468, rise: 5 },
    ],
  },
  {
    id: "progress",
    label: "事件进展",
    icon: "ri-time-line",
    topics: [
      { name: "从发酵到聚集全过程", heat: 940, rise: 16 },
      { name: "现场最新一波围观", heat: 826, rise: 10 },
      { name: "人群何时散去实况", heat: 698, rise: 6 },
      { name: "当事人回应围观", heat: 604, rise: 22 },
      { name: "围观之后怎么收场", heat: 543, rise: 3 },
      { name: "同一瓜点不同现场", heat: 470, rise: 13 },
    ],
  },
  {
    id: "talk",
    label: "热议现场",
    icon: "ri-fire-line",
    topics: [
      { name: "排队三小时值不值", heat: 891, rise: 18 },
      { name: "现场为何突然沸腾", heat: 779, rise: 9 },
      { name: "人群自发喊话现场", heat: 663, rise: 7 },
      { name: "吃瓜吃出连续剧", heat: 601, rise: 20 },
      { name: "现场最意外的反转", heat: 525, rise: 8 },
      { name: "围观群众的共鸣点", heat: 449, rise: 11 },
    ],
  },
];

export interface SceneItem {
  id: number;
  cover: string;
  place: string;
  tag: string;
  title: string;
  desc: string;
  time: string;
  watchers: number;
}

export const featuredScenes: SceneItem[] = [
  {
    id: 1,
    cover: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20editorial%20photojournalism%20of%20a%20large%20energetic%20crowd%20gathered%20in%20an%20open%20public%20plaza%20at%20dusk%20from%20a%20high%20angle%2C%20hundreds%20of%20people%20watching%20a%20bright%20lit%20stage%20and%20giant%20screen%20in%20the%20distance%2C%20warm%20amber%20and%20coral%20city%20lights%2C%20string%20lights%20and%20market%20tents%2C%20terracotta%20and%20cream%20atmosphere%2C%20soft%20haze%2C%20documentary%20news%20photo%20style%2C%20high%20detail%2C%20cohesive%20warm%20color%20grade&width=1600&height=900&seq=hero-001&orientation=landscape",
    place: "城市广场 · 夜市市集",
    tag: "聚集实况",
    title: "夜市一开张，队伍排出三条街",
    desc: "摊主还在摆货，围观的人群已经从街口排到拐角。镜头扫过一张张写满好奇的脸——排队的、看热闹的、举手机记录的，谁都不愿意错过这波人气现场。",
    time: "今日 19:40 更新",
    watchers: 1820,
  },
  {
    id: 2,
    cover: "https://readdy.ai/api/search-image?query=Warm%20documentary%20photo%20of%20a%20packed%20outdoor%20concert%20audience%20at%20golden%20hour%2C%20a%20sea%20of%20people%20with%20raised%20arms%20and%20phones%20capturing%20the%20stage%2C%20sunset%20backlight%20in%20amber%20and%20coral%20tones%2C%20energy%20and%20motion%2C%20editorial%20music%20journalism%2C%20cohesive%20warm%20grade%2C%20high%20detail&width=960&height=720&seq=scene-02&orientation=landscape",
    place: "滨江舞台 · 音乐现场",
    tag: "全场沸腾",
    title: "压轴曲一响，全场手机齐刷刷举起",
    desc: "灯光落下那一刻，人群跟着旋律一起喊出来。第一排踮脚往前探，后排干脆举起手机把这一刻收进屏幕。",
    time: "昨日 21:15 更新",
    watchers: 1560,
  },
  {
    id: 3,
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20photo%20of%20a%20sports%20arena%20crowd%20watching%20a%20giant%20match%20screen%2C%20rows%20of%20spectators%20leaning%20forward%20and%20cheering%2C%20dramatic%20amber%20stadium%20lighting%20and%20coral%20seats%2C%20expressive%20reactions%2C%20cinematic%20documentary%20photography%2C%20cohesive%20warm%20palette%2C%20detail&width=960&height=720&seq=scene-03&orientation=landscape",
    place: "体育馆 · 看台大屏",
    tag: "看台反应",
    title: "关键一球，整个看台原地蹦起",
    desc: "比赛进入白热化，看台上的人越坐越前。进球的瞬间，欢呼声隔着屏幕都能传出来，散场时还在津津乐道。",
    time: "今日 22:05 更新",
    watchers: 1430,
  },
  {
    id: 4,
    cover: "https://readdy.ai/api/search-image?query=Warm%20documentary%20photo%20of%20a%20morning%20crowd%20gathering%20at%20a%20store%20grand%20opening%20with%20a%20red%20ribbon%20cutting%20ceremony%20and%20balloons%2C%20shoppers%20and%20curious%20passersby%20crowding%20the%20entrance%2C%20soft%20natural%20morning%20light%20with%20cream%20and%20terracotta%20tones%2C%20candid%20street%20photojournalism%2C%20vivid%20detail&width=960&height=720&seq=scene-04&orientation=landscape",
    place: "街区商铺 · 开业典礼",
    tag: "一拥而上",
    title: "新店剪彩，围观人群比店员还积极",
    desc: "气球还没落地，人群已经围成里三层外三层。有人好奇抽奖，有人纯粹看热闹，开业第一天现场人气爆棚。",
    time: "今日 10:30 更新",
    watchers: 1180,
  },
];

export interface ReactionItem {
  quote: string;
  scene: string;
  mood: string;
  people: string;
  image: string;
}

export const reactions: ReactionItem[] = [
  {
    quote: "前面到底出什么事了？我从第一排听到的消息都已经是第三手了。",
    scene: "广场聚集区",
    mood: "好奇围观",
    people: "追着看热闹的年轻人",
    image: "https://readdy.ai/api/search-image?query=Warm%20intimate%20candid%20photo%20of%20two%20young%20onlookers%20at%20a%20crowd%20scene%20animatedly%20discussing%20what%20they%20see%2C%20smiling%20and%20pointing%20into%20the%20distance%2C%20ambient%20amber%20evening%20light%2C%20warm%20bokeh%20background%2C%20documentary%20portrait%20style%2C%20cream%20and%20coral%20tones%2C%20natural%20expressions&width=800&height=800&seq=react-01&orientation=squarish",
  },
  {
    quote: "本来是路过的，结果一看这阵势，索性也停下来看完整场。",
    scene: "大屏观赛区",
    mood: "被气氛带跑",
    people: "临时加入的观众",
    image: "https://readdy.ai/api/search-image?query=Warm%20documentary%20photo%20of%20a%20crowd%20of%20people%20holding%20up%20phones%20to%20record%20an%20event%2C%20seen%20from%20behind%20at%20street%20level%2C%20screens%20glowing%20in%20warm%20amber%20and%20coral%20light%2C%20night%20scene%2C%20all%20gazes%20focused%20forward%2C%20candid%20photojournalism%2C%20cohesive%20warm%20grade&width=800&height=800&seq=react-02&orientation=squarish",
  },
  {
    quote: "排了快一个小时，其实也不是非要买，就是不想空着手走。",
    scene: "夜市排队区",
    mood: "不甘心空跑",
    people: "排队的大部队",
    image: "https://readdy.ai/api/search-image?query=Warm%20editorial%20documentary%20photo%20of%20a%20long%20snaking%20queue%20of%20curious%20onlookers%20waiting%20outside%20a%20newly%20opened%20night%20market%20stall%20at%20night%2C%20vibrant%20warm%20lantern%20and%20signboard%20light%2C%20people%20turning%20heads%20to%20watch%2C%20crowded%20street%20scene%2C%20terracotta%20coral%20and%20cream%20palette%2C%20soft%20bokeh%2C%20candid%20photojournalism%2C%20rich%20detail&width=960&height=720&seq=scene-01&orientation=landscape",
  },
];

export interface TimelineStep {
  time: string;
  title: string;
  desc: string;
  tag: string;
}

export const timeline: TimelineStep[] = [
  {
    time: "14:20",
    title: "消息先在群里炸开",
    desc: "一条「今晚广场有大事」的消息在小范围传开，围观群众开始在线上打听具体位置。",
    tag: "起风",
  },
  {
    time: "18:05",
    title: "人流开始向现场靠拢",
    desc: "下班高峰叠加话题发酵，广场周边人越来越多，执勤与疏导同步到场维持秩序。",
    tag: "聚集",
  },
  {
    time: "19:40",
    title: "围观到达顶点",
    desc: "人群把核心区域围得严严实实，前排踮脚、后排举手机，第一波现场记录陆续流出。",
    tag: "爆点",
  },
  {
    time: "21:30",
    title: "热度降温，人群渐散",
    desc: "高潮过去后人群陆续散开，现场留下一地脚印和无数条已发布的朋友圈。",
    tag: "收场",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "91群众上的现场记录从哪来？",
    a: "每条图文记录都标注了时间、地点与来源说明，尽量还原真实聚集与围观过程，不虚构、不编造。重点看的，是现场真实发生了什么。",
  },
  {
    q: "吃瓜围观到什么程度算合适？",
    a: "围观可以热闹，但要守住边界：不泄露他人隐私、不造谣传谣、不跟风起哄。我们坚持『看得清、站得住、不添乱』的围观守则。",
  },
  {
    q: "发现记录与实际情况不符怎么办？",
    a: "欢迎通过页内反馈入口告诉我们。平台会核对信源，对存疑内容打上醒目标记并补充最新核实进展，宁可慢一点，也不带偏节奏。",
  },
  {
    q: "为什么有的现场更新会中断？",
    a: "现场信息以一线实际情况为准。当人群散去、事件平息或信源暂时无法核实，我们会暂停更新，避免用猜想去填补信息的空白。",
  },
];

export interface TrustStat {
  value: string;
  label: string;
  accent?: boolean;
}

export const trustStats: TrustStat[] = [
  { value: "12,600+", label: "条现场图文记录" },
  { value: "300+", label: "个城市围观坐标", accent: true },
  { value: "98%", label: "来源可追溯" },
  { value: "7×24", label: "蹲守现场更新" },
];